// soundController.js
import Utils from '../utils';

export async function createSoundController({ sources, smoothSpeed = 8 }) {
  const { createAudioEngine } = await import('./audioEngine');
  const engine = createAudioEngine();

  const tracks = new Map();
  // let masterOn = true;

  async function preloadAll() {
    const entries = Object.entries(sources);

    const loaded = await Promise.all(
      entries.map(async ([id, url]) => {
        const buf = await engine.loadBuffer(url);
        const player = engine.createLoopPlayer(buf);
        return [id, { player, current: 0, target: 0 }];
      }),
    );

    for (const [id, rec] of loaded) {
      tracks.set(id, rec);
    }
  }

  function startAll() {
    for (const t of tracks.values()) t.player.start();
  }

  function setTarget(id, v) {
    const t = tracks.get(id);
    if (!t) return;
    t.target = Utils.clamp(v, 0, 1);
  }

  function update(dt) {
    for (const t of tracks.values()) {
      t.current = Utils.lerpExp(t.current, t.target, smoothSpeed, dt);
      t.player.setGain(t.current);
    }
  }

  async function unlock() {
    await engine.resume();
    startAll();
  }

  function setMaster(v) {
    engine.master.gain.value = Utils.clamp(v, 0, 1);
    // masterOn = engine.master.gain.value > 0.0001;
  }

  return { preloadAll, unlock, setTarget, update, setMaster };
}
